import { jsPDF } from 'jspdf'
import { filter, isEmpty } from 'lodash'

import moment from 'moment'

import pages from './pages'
import templates from '../templates'

import '../fonts/Raleway-Bold-normal'
import '../fonts/Raleway-Thin-normal'
import '../fonts/Roboto-Regular-normal'
import '../fonts/Roboto-Bold-normal'

import * as service from 'service'
import constants from 'constants/index'

moment.locale('pt-br')
var dateNow = moment().format('DD/MM/YYYY')

const exportPdf = async (
  customStyles,
  customLogo,
  questionnaires,
  questionControls,
  supplier,
  setExportingPdf,
  snackbar,
  partnerReport = false,
  shouldCreateVersion = false,
  refresh = () => {},
  company = {},
  qrCode = '',
) => {
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    userUnit: 300,
  })

  const reportTitle = partnerReport
    ? 'Relatório de Fornecedor'
    : 'Relatório de Medidas de Segurança do Fornecedor'

  const nameCover = partnerReport ? company?.name : supplier?.name
  const documentCover = partnerReport ? company?.document : supplier?.document

  try {
    templates.firstCover({
      pdf,
      companyName: nameCover,
      document: documentCover,
      date: dateNow,
      customStyles,
      customLogo,
      reportName: reportTitle,
      qrCode,
    })

    const lineName = partnerReport ? 'Fornecedor' : 'Medidas de Segurança'

    pages.generalInformations(
      pdf,
      `${lineName} | ${dateNow}`,
      questionnaires,
      customStyles,
      partnerReport,
      supplier?.name,
    )

    pages.questionControls(pdf, `${lineName} | ${dateNow}`, questionControls)

    const questionnairesWithQuestionNotApplicable = filter(
      questionnaires,
      (questionnaire) =>
        questionnaire.questionsNotApplicable &&
        questionnaire.questionsNotApplicable.length > 0,
    )

    if (!isEmpty(questionnairesWithQuestionNotApplicable) && partnerReport) {
      pages.notApplicableQuestions({
        pdf,
        date: `${lineName} | ${dateNow}`,
        questionnairesWithQuestionNotApplicable,
      })
    }

    templates.lastCover({ pdf, customStyles, customLogo })

    const reportInitialName = partnerReport
      ? 'Relatório_de_Fornecedor'
      : 'Relatório_de_Medidas_de_Segurança_do_Fornecedor'

    const reportName = `${reportInitialName}_${supplier?.name
      ?.split(' ')
      ?.join('_')
      ?.toLowerCase()}_${dateNow}.pdf`

    pdf.save(reportName)

    if (shouldCreateVersion) {
      const file = new File([pdf.output('blob')], reportName)
      await service.dponet.reportVersions.create({
        file,
        name: reportTitle,
        kind: constants.reportVersions.KIND.PARTNER,
      })
      refresh()
    }

    snackbar.open({
      variant: 'success',
      message: 'Relatório gerado com sucesso, aguarde o download começar',
    })
  } catch (error) {
    console.error(error)
    snackbar.open({
      variant: 'error',
      message: 'Ocorreu um erro ao gerar o relatório',
    })
  } finally {
    setExportingPdf(false)
  }
}

export default exportPdf
